"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DashboardTache_1 = require("./DashboardTache");
var DashboardAffaireTaches = /** @class */function () {
    function DashboardAffaireTaches(data) {
        this.taches = [];
        if (data != null) {
            this.idAffaire = data.idAffaire;
            this.codeAffaire = data.codeAffaire;
            this.codeEnedis = data.codeEnedis;
            this.dateCreation = data.dateCreation;
            this.libelle = data.libelle;
            this.statut = data.statut;
            this.codeInsee = data.codeInsee;
            this.commune = data.commune;
            this.type = data.type;
            this.idBonCommande = data.idBonCommande;
            this.numBonCommande = data.numBonCommande;
            for (var _i = 0, _a = data.taches; _i < _a.length; _i++) {
                var tache = _a[_i];
                this.taches.push(new DashboardTache_1.DashboardTache(tache));
            }
        }
    }
    return DashboardAffaireTaches;
}();
exports.DashboardAffaireTaches = DashboardAffaireTaches;


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Dashboard/Models/DashboardAffaireTaches.ts
// module id = 532
// module chunks = 0